import React, { FC } from 'react';
import styled from 'styled-components';

import { ReadMore } from '~/atomic/molecula/ReadMore';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { AuthorCycle } from '~/atomic/page/author/books/AuthorCycle';
import { EmptyAuthorBooksPage } from '~/atomic/page/author/books/EmptyAuthorBooksPage';
import { SCContent } from '~/atomic/page/author/styled';
import { PageTitleStyle } from '~/atomic/Typography';
import { cycleSelector, defaultCycleName } from '~/feature/cycle/cycleSlice';
import { Linkify } from '~/feature/utils/Linkify';
import { useAppSelector } from '~/store';

export const AuthorBooks: FC = () => {
  const { cyclesWithBooks } = useAppSelector(cycleSelector);
  const { currentAuthor } = useAppSelector(authorSelector);
  const authorBooksCount = cyclesWithBooks
    .map((cycle) => cycle.books.length)
    .reduce((acc, cycle) => acc + cycle, 0);

  let cycles = [];
  let defaultCycle;

  if (authorBooksCount < 1) return <EmptyAuthorBooksPage />;

  const defaultCycleIndex = cyclesWithBooks.findIndex(
    (prevCycle) => (prevCycle.name === defaultCycleName),
  );

  if (defaultCycleIndex !== -1) {
    const { [defaultCycleIndex]: defCycle, ...restCycles } = cyclesWithBooks;
    defaultCycle = defCycle;
    cycles = Object.values(restCycles);
  } else {
    cycles = cyclesWithBooks;
  }

  return (
    <SCContent>
      <SCTitle>
        Книги автора
        {' '}
        {currentAuthor.name}
      </SCTitle>
      <>
        {currentAuthor?.aboutMe && (
          <Linkify>
            <SCAuthorDescription>
              <ReadMore
                text={currentAuthor.aboutMe}
              />
            </SCAuthorDescription>
          </Linkify>
        )}
        {cycles.map((cycle) => (
          <AuthorCycle key={`author-cycle-id-${cycle.id}`} cycle={cycle} />
        ))}
        {defaultCycle && (
          <AuthorCycle key={`author-cycle-id-${defaultCycle.id}`} cycle={defaultCycle} />
        )}
      </>
    </SCContent>
  );
};

const SCAuthorDescription = styled.div`
  white-space: pre-line;
  margin-top: 15px;
`;

const SCTitle = styled.h1`
  ${PageTitleStyle};
`;
